import React from 'react';
import { motion } from 'framer-motion';
import { FadeIn } from './FadeIn';
export function HackSection() {
  return <section className="pt-8 pb-16 md:pt-12 md:pb-32 relative" data-id="element-140">
      <div className="absolute inset-0 z-0" data-id="element-141">
        <img src="https://images.unsplash.com/photo-1502161254066-6c74afbf07aa?q=80&w=2000&auto=format&fit=crop" alt="Dark Parisian Cafe" className="w-full h-full object-cover opacity-20 fixed" data-id="element-142" />
        <div className="absolute inset-0 bg-gradient-to-b from-deep-black via-deep-black/90 to-deep-black" data-id="element-143"></div>
      </div>

      <div className="max-w-3xl mx-auto px-6 relative z-10 text-center" data-id="element-144">
        <FadeIn data-id="element-145">
          <h2 className="font-playfair text-3xl md:text-5xl text-champagne-gold leading-tight mb-8" data-id="element-146">
            Le secret des femmes qu'on n'ose pas ghoster
          </h2>
        </FadeIn>

        <FadeIn delay={0.2} data-id="element-147">
          <p className="text-muted-cream font-light leading-relaxed text-lg md:text-xl mb-12" data-id="element-148">
            Ce n'est pas la beauté. Ce n'est pas la chance. C'est une méthode.
            La méthode du{' '}
            <strong className="text-cream font-medium" data-id="element-149">
              Chaud-Froid Cognitif
            </strong>
            . Quoi dire. Quand répondre. Quand disparaître.
          </p>
        </FadeIn>

        <FadeIn delay={0.4} data-id="element-150">
          <motion.a href="https://redevenirmoi.com/cart/53549720371568:1" target="_blank" rel="noopener noreferrer" whileHover={{
          scale: 1.03
        }} whileTap={{
          scale: 0.97
        }} className="inline-flex items-center justify-center px-10 py-5 text-base md:text-lg font-bold text-deep-black uppercase tracking-widest bg-champagne-gold rounded-full shadow-gold-glow hover:shadow-gold-glow-lg transition-all duration-300 no-underline cursor-pointer" data-id="element-151">
            JE VEUX LA MÉTHODE — 9,97$
          </motion.a>
        </FadeIn>
      </div>
    </section>;
}